require("!!/Users/mattijsnaus/Documents/chillyorange/Builder/sbpro/node_modules/script-loader/addScript.js")(require("!!/Users/mattijsnaus/Documents/chillyorange/Builder/sbpro/node_modules/raw-loader/index.js!/Users/mattijsnaus/Documents/chillyorange/Builder/sbpro/assets/js/vendor/summernote.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./assets/js/vendor/summernote.min.js
// module id = 69
// module chunks = 1